export default __webpack_public_path__ + "static/media/Strugani 4.f575734f.jpg";